// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview-wrapper_wrapper__1hJVw","title":"preview-wrapper_title__2F372"};